import React from "react";
import CloudSecurityCenter from "./CloudSecurityCenter.jsx";

const CloudTechnicalRoute = ({ provider, view = "misconfiguration" }) => (
  <CloudSecurityCenter
    initialProviderScope={provider}
    initialWorkspace="technical"
    initialTechnicalView={view}
  />
);

export const GcpMisconfigurations = () => (
  <CloudTechnicalRoute provider="gcp" view="misconfiguration" />
);
export const GcpNetworkVulnerabilities = () => (
  <CloudTechnicalRoute provider="gcp" view="network" />
);
export const GcpWebVulnerabilities = () => (
  <CloudTechnicalRoute provider="gcp" view="web" />
);
export const OciMisconfigurations = () => (
  <CloudTechnicalRoute provider="oci" view="misconfiguration" />
);
export const OciNetworkVulnerabilities = () => (
  <CloudTechnicalRoute provider="oci" view="network" />
);
export const OciWebVulnerabilities = () => (
  <CloudTechnicalRoute provider="oci" view="web" />
);

export default CloudTechnicalRoute;
